module.exports = __webpack_public_path__ + "./fonts/montserrat-latin-400italic.882908d9950d9c86ebd380877f293d95.woff2";